export const Products=[
    {
        id: 1,
        productName: "Apple iPhone 14 Pro (1 TB) - Space Black",
        price: 999.0,
        productImage: "https://www.designinfo.in/wp-content/uploads/2023/01/Apple-iPhone-14-Pro-Mobile-Phone-493177786-i-1-1200Wx1200H-optimized.jpeg",
    },
    {
        id: 2,
        productName: "Miraan Men's Long Sleeve Casual Denim Shirt (SIGDENIM)",
        price: 999.0,
        productImage: "https://media.istockphoto.com/id/584479824/photo/blue-jean-shirt-isolated-on-white-background.jpg?s=612x612&w=0&k=20&c=_yZ_NkKcn_P-eFVlqtB2RsAx8A9sFEQIjSU_xTwIFdY=",
    },
    {
        id: 3,
        productName: "Sheetal Associates Women Full Sleeve V-Neck Bodycon Casual Knee Length Dress",
        price: 999.0,
        productImage: "https://media.istockphoto.com/id/934408078/photo/navy-blue-retro-dress-with-short-sleeves-isolated-on-white.jpg?s=612x612&w=0&k=20&c=dswfh1z5uFQzaOmt1PMoYWDXA_gHVO366UJ7K-HRyh8=",
    },
    {
        id: 4,
        productName: "Watches for Men Round Studded Dial Analogue Quartz Day & Date Movemne Long Battery",
        price: 999.0,
        productImage: "https://previews.123rf.com/images/doomu/doomu1708/doomu170800297/85085005-luxury-classic-analog-men-s-wrist-silver-watch-on-a-white-background-3d-rendering.jpg",
    },
    {
        id: 5,
        productName: "Bluetooth Headphones, Premium Active Noise Cancelling Wireless Headphones Over Ear, 50H Playtime, Hi-Res Audio, Deep Bass, Memory Foam Ear Cups for Travel, Home Office",
        price: 999.0,
        productImage: "https://media.istockphoto.com/id/538264791/photo/headphone.jpg?s=612x612&w=0&k=20&c=Cc8nKJk1TNOnE19VvrEfjP8C0a389tNJOUXS67hhSOY="
    },
    {
        id: 6,
        productName: "SteelSeries Apex 3 Keyboard – Tenkeyless Compact Form Factor - 8-Zone RGB Illumination – IP32 Water & Dust Resistant – Whisper Quiet Gaming Switch – Gaming Grade Anti-Ghosting,Black",
        price: 999.0,
        productImage: "https://t3.ftcdn.net/jpg/02/37/70/96/360_F_237709628_GbyhqnU6MGLT2JdgvFEzZ8sD61fkXNNe.jpg"
    }
    
]